export function randomBase64Url(byteSize = 12) {
    const bytes = crypto.getRandomValues(new Uint8Array(byteSize));
    const binary = String.fromCharCode(...bytes);
    return btoa(binary)
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=+$/, "");
}
export function withRandomId(obj) {
    return {
        ...obj,
        id: obj.id ?? randomBase64Url(),
    };
}
